<template>
    <el-dialog
        class="Confirm"
        :visible.sync="confirmVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Confirm"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="confirmForm"
                :model="confirmForm"
                :rules="rules"
                label-width="70px"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Amount" prop="money" size="small">
                            <el-input
                                type="number"
                                v-model="confirmForm.money"
                                placeholder="Please input amount"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Remark" prop="remark" size="small">
                            <el-input
                                type="textarea"
                                v-model="confirmForm.remark"
                                placeholder="Please input remark"
                                :autosize="{ minRows: 6, maxRows: 8}"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="confirmVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            confirmForm: {
                money: "",
                remark: "",
            },
            rules: {
                money: [
                    {
                        required: true,
                        message: "Please input amount",
                    },
                ],
                remark: [
                    {
                        required: false,
                        message: "Please input remark",
                    },
                ],
            },
        };
    },
    methods: {
        closeDialog() {
            this.confirmForm = {
                money: "",
                remark: "",
            };
            this.$refs["confirmForm"].clearValidate();
            this.$refs["confirmForm"].resetFields();
            this.$emit("update:confirmVisible", false);
        },
        save() {
            this.$refs["confirmForm"].validate((valid) => {
                if (valid) {
                    cmofferApi
                        .rechargeExamine(
                            {
                                ...this.confirmForm,
                                status: 2
                            },
                            "post",
                            this.tableItem.id
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName] &&
                                    this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        rechargeExamine() {
            cmofferApi
                .rechargeExamine({}, "get", this.tableItem.id)
                .then((res) => {
                    if (res) {
                        this.confirmForm.money = res.data.money;
                        this.confirmForm.remark = res.data.desc;
                    }
                });
        },
    },
    props: {
        confirmVisible: Boolean,
        tableItem: Object,
        funcName: String,
    },
    watch: {
        confirmVisible(val) {
            this.rechargeExamine();
        },
    },
};
</script>
<style lang="scss" scoped>
.Confirm {
    .container {
    }
}
</style>
